<template>
    <div>
    <a target="_blank" href="https://api.whatsapp.com/send?phone=5519987656288&amp;text=Olá%20Marcio%20Gomes%20e%20Guincho,%20Gostaria%20de%20solicitar%20um%20orçamento." class="whatsapp-button">
        <img src="@/assets/whatsapp-32.svg" alt="" width="32" height="32">
    </a>
  </div>
    <br><br><br><br><footer class="footer-section">
        <div class="container">
            <div class="footer-content">
                <div class="row">
                    <div>
                        <h3>Sobre Nós</h3>
                        <p><span>A</span> <strong>Márcio Gomes Guincho</strong><span>&nbsp;oferece serviços de guincho e
                                reboque 24 horas por dia, 7 dias por semana, com atendimento rápido e eficiente em toda
                                a região. Nossa equipe de profissionais altamente qualificados está sempre pronta para
                                ajudar em situações de emergência, garantindo a segurança e a tranquilidade dos nossos
                                clientes. Confie na experiência e dedicação da Márcio Gomes Guincho para resolver os
                                seus problemas de transporte de veículos.</span></p>
                    </div>
                    <div>
                        <h3>Serviços</h3>
                        <ul>
                            <li><router-link to="/guincho-para-carros/">Guincho para Carros</router-link></li>
                            <li><router-link to="/guincho-para-motos/">Guincho para Motos</router-link></li>
                            <li><router-link to="/guincho-para-motonetas/">Guincho para Motonetas</router-link></li>
                            <li><router-link to="/guincho-para-maquinas/">Guincho para Máquinas</router-link></li>
                            <li><router-link to="/guincho-para-equipamentos/">Guincho para Equipamentos</router-link></li>
                            <li><router-link to="/guincho-para-quadriciclos/">Guincho para Quadriciclos</router-link></li>
                            <li><router-link to="/guincho-para-triciclos/">Guincho para Triciclos</router-link></li>
                            <li><router-link to="/guincho-para-vans/">Guincho para Vans</router-link></li>
                            <li><router-link to="/guincho-para-peruas/">Guincho para Peruas</router-link></li>
                            <li><router-link to="/guincho-para-bobcats/">Guincho para Bobcats</router-link></li>
                            <li><router-link to="/guincho-para-utilitarios/">Guincho para Utilitários</router-link></li>
                            <li><router-link to="/guincho-para-barcos/">Guincho para Barcos</router-link></li>
                            <li><router-link to="/guincho-para-jet-skis/">Guincho para Jet-skis</router-link></li>
                            <li><router-link to="/guincho-para-lanchas/">Guincho para Lanchas</router-link></li>
                        </ul>
                    </div>
                    <div>
                        <h3>Informações Do Negócio</h3>
                        <div class="contact-info">
                            <a target="_blank" href="https://www.google.com/maps/search/Rua%20Otávio%20Rosolen%20-%20Jardim%20Terras%20de%20Santo%20Antonio,%20Hortolândia%20-%20SP,%2013185-563,%20Brasil" class="icon-text"><i class="fas fa-map-marker-alt"></i><span>Rua Otávio Rosolen - Jardim Terras de Santo Antonio, Hortolândia - SP, 13185-563, Brasil</span></a>
                            <a target="_blank" href="tel:19987656288" class="icon-text"><i class="fas fa-phone"></i><span>(19) 9 8765-6288</span></a>
                            <a target="_blank" href="mailto:contato@marciogomesguincho.com.br" class="icon-text"><i class="far fa-envelope-open"></i><span>contato@marciogomesguincho.com.br</span></a>
                        </div>
                    </div>
                   <!--  <div>
                        <h3>Newsletter</h3>
                        <p>Inscreva-se para receber nossas novidades e ofertas especiais:</p>
                        <div class="subscribe-form">
                            <form action="#">
                                <input type="email" placeholder="Seu email" required>
                                <button aria-label="Enviar mensagem"><i class="fab fa-telegram-plane"></i></button>
                            </form>
                        </div>
                        <div class="footer-social-icon">
    <span>Siga-nos</span>
    <a href="#" aria-label="Facebook">
        <i class="fab fa-facebook-f facebook-bg" aria-hidden="true"></i>
    </a>
    <a href="#" aria-label="Twitter">
        <i class="fab fa-twitter twitter-bg" aria-hidden="true"></i>
    </a>
    <a href="#" aria-label="Google Plus">
        <i class="fab fa-google-plus-g google-bg" aria-hidden="true"></i>
    </a>
</div>

                    </div> -->
                </div>
            </div><br><br><br>
            <div class="copyright-area">
                <div class="">
                    <ul class="footer-menu">
                        <li><router-link to="/">Home</router-link></li>
                        <!-- <li><router-link to="/termos">Termos</router-link></li>
                        <li><router-link to="/privacidade">Privacidade</router-link></li>
                        <li><router-link to="/politica">Política</router-link></li> -->
                        <li><router-link to="/">Contato</router-link></li>
                    </ul>
                </div>
                <div class="">
                    <p>&copy; {{ year }} - Todos os direitos reservados</p>
                </div>

            </div>
        </div>
    </footer>
</template>

<script>
import '@fortawesome/fontawesome-free/css/all.css'
export default {
  name: 'FooterComponent',
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
i{
    padding: 7px
}
.footer-content{
    padding: 0 5px;
}
.icon {
    display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 18px;
    margin-right: 5px;
    color: #70778b;
    font-size: 10px;
    text-align: center;
    background-color: #f3f3f6;
    vertical-align: middle;
    border-radius: 50%;
}
.row {
    display: flex;
    flex-wrap: wrap;
    div {
        width:calc(98vw/4)!important;
        @media only screen and (max-width: 600px) {
            min-width: 100vw!important;
}
    }
}
*{
    overflow: hidden!important;
}
.footer-section {
    background: #151414;
    color: #878787;
    padding: 60px 0 2px 0;
}

ul li {
    margin-bottom: 10px;
    padding-left: 10px;
}

ul li a {
    color: #878787;
    text-decoration: none;
    transition: color 0.3s ease;
}

ul li a:hover {
    color: #ff5e14;
}

.contact-info .icon-text {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    color:#878787!important
}

.contact-info .icon-text i {
    margin-right: 10px;
    font-size: 20px;
    color: #ff5e14;
}

.subscribe-form input[type="email"] {
    width: 60%;
    padding: 12px;
    border: none;
    outline: none;
    font-size: 14px;
    background-color: #fff;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

.subscribe-form button {
    padding: 12px 20px;
    border: none;
    cursor: pointer;
    background-color: #ff5e14;
    height: 40.8px;
    margin-left: 2px;
    color: #fff;
    font-size: 16px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

.subscribe-form button:hover {
    background-color: #e64906;
}

.footer-social-icon {
    margin-top: 20px;
}

.footer-social-icon span {
    display: block;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 10px;
}

.footer-social-icon a {
    color: #fff;
    font-size: 20px;
    margin-right: 10px;
}

.footer-social-icon a:hover {
    color: #ff5e14;
}

.footer-menu {
    display: flex;
    text-align: center;
    flex-wrap: wrap;
    justify-content: center
}

.footer-menu li {
    margin: 0 10px;
}

.footer-menu li a {
    color: #878787;
    text-decoration: none;
    transition: color 0.3s ease;
}

.footer-menu li a:hover {
    color: #ff5e14;
}

.copyright-area {
    background-color: #1c1b1b;
    padding: 15px 0;
    color: #fff;
    text-align: center;
    div{
        margin: 0 auto!important;
    }
}
.copyright{
    display: flex;
    justify-content: center;
}
@media (max-width: 767px) {
    .footer-menu {
        margin-top: 30px;
    }
}
.whatsapp-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background-color: #25D366;
        width: 48px;
        height: 48px;
        padding: 20px;
        font-size: 16px;
        border-radius: 100%;
        text-decoration: none;
        transition: background-color 0.3s ease;
        position: fixed;
        bottom: 2vh;
        right: 5vw;
        @media only screen and (max-width: 600px) {
        }
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        z-index: 1000;
        animation: pulse 1.5s infinite;
    }

    .whatsapp-button:hover {
        background-color: #128C7E;
    }

    .whatsapp-button i {
        margin-right: 10px;
        font-size: 20px;
    }

    @keyframes pulse {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.1);
        }
        100% {
            transform: scale(1);
        }
    }
</style>
